<template>
  <div>
    <div class="uk-width-large uk-margin-auto">
      <div class="uk-card uk-card-default">
        <div class="uk-card-header">
          <h3 class="uk-card-title uk-margin-remove-bottom uk-text-center">Booking Notifications</h3>
        </div>
        <div class="uk-card-body">
          <div>Send confirmation to customer?</div>
          <div class="uk-margin-small-top uk-margin-bottom">
            <label class="uk-margin-small-right uk-margin-small-left" for="email-checkbox"><input id="email-checkbox" v-model="notifications.customer.email" class="uk-checkbox" type="checkbox" data-cy="notification-email"> Email</label>
            <label class="uk-margin-small-right uk-margin-small-left" for="sms-checkbox"><input id="sms-checkbox" v-model="notifications.customer.phone" class="uk-checkbox" type="checkbox" data-cy="notification-sms"> SMS</label>
          </div>

          <div v-if="notifications.dentist.phone || notifications.dentist.email">
            Dentist will receive <span v-if="notifications.dentist.phone">Phone</span><span v-if="notifications.dentist.phone && notifications.dentist.email"> and </span><span v-if="notifications.dentist.email">Email</span> notifications.
          </div>

          <div v-else>Dentist will not receive any notifications, because they did not request any!</div>
        </div>
        <div class="uk-card-footer uk-text-center">
          <button class="uk-button uk-button-primary" uk-tooltip="Book a New Appointment" data-cy="continue" @click="next">Continue</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentAppointmentNotifications',

  props: {
    appointmentId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      notifications: {
        dentist: {
          phone: true,
          email: true
        },
        customer: {
          phone: true,
          email: true
        }
      }
    }
  },

  computed: {
    appointment() {
      return this.appointmentId ? this.$store.getters['appointments/find'](this.appointmentId) : null
    }
  },

  created() {
    const dentist = this.$store.getters['dentists/find'](this.appointment.info.dentist) || null


    if (this.appointment && dentist) {
      this.notifications.dentist.phone = dentist.notifications.phone
      this.notifications.dentist.email = dentist.notifications.email

      if (this.appointment.customer.contact.phone) {
        this.notifications.customer.phone = true
      }

      if (this.appointment.customer.contact.email) {
        this.notifications.customer.email = true
      }
    }
  },

  methods: {
    next() {
      this.$bus.$emit('appointment-section-complete', { type: 'notifications', data: this.notifications.customer })
    }
  }
}
</script>
